export default __webpack_public_path__ + "static/media/view all icon.92cc37f7.png";